import React, { useContext, useEffect } from 'react';
import { Walkthrough, withLocalization } from '@adac-mp/components';
import { createSearchParams } from 'react-router-dom';

import { IOfferContext, OfferContext, countryUrlMap, getUrlBasePath, setRouteLangParam } from '@adac-mp/shared';

import VignetteStart from '../../assets/images/Start-Vignette-Österreich.svg';
const IntroAutComponent = () => {
	const { lang } = useContext<IOfferContext>(OfferContext);
	const params = createSearchParams();
	params.set('step', '1');

	useEffect(() => {
		sessionStorage.setItem('flowId', '3');
	}, []);

	return (
		<Walkthrough
			title="Servus"
			text="Mit der digitalen Vignette und digitalen Streckenmaut bequem auf Autobahnen und Schnellstraßen in Österreich unterwegs – gebührenfrei und sofort ab Kauf gültig."
			linkUrl={getUrlBasePath(`/${countryUrlMap[3]}/configure${setRouteLangParam(lang)}`, params)}
			slug={`${countryUrlMap[3]}`}
			image={VignetteStart}
			country="österreich"
			tracking={{
				funnel_view: {
					label: 'E-Vignette Österreich',
					element: 'Onboarding',
					trackOnce: true,
				},
			}}
		/>
	);
};

export const IntroAut = withLocalization(IntroAutComponent);
